export enum GenderType {
  MALE = 'male',
  FEMALE = 'female',
  UNISEX = 'unisex',
}
